/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rate_Prompt_TitleInputs */

const en_rate_prompt_title = /** @type {(inputs: Rate_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoying Listening?`)
};

const es_rate_prompt_title = /** @type {(inputs: Rate_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Te gusta Listening?`)
};

/**
* | output |
* | --- |
* | "Enjoying Listening?" |
*
* @param {Rate_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const rate_prompt_title = /** @type {((inputs?: Rate_Prompt_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rate_Prompt_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_rate_prompt_title(inputs)
	return en_rate_prompt_title(inputs)
});